<template>
  <div class="list-analytics">
    <div>
      <highcharts class="chart" :options="options" ref="highchart" />
      <el-scrollbar class="status">
        <ul class="list list-event">
          <li v-for="point in legendPoints" :key="point.key" :class="getLegendClass(point.series)" :style="{borderColor: point.color}" >
            <span class="number">{{ convertValuByUnit(point) }}</span>
            <el-tooltip placement="bottom">
              <div slot="content">
                <ul>
                  <li>{{ convertObjName(point.series) }}</li>
                  <li>{{ convertLegendName(point.series) }}</li>
                </ul>
              </div>
              <span class="content" @click="onClickLegend(point.series)">
                <strong>{{ convertObjName(point.series) }}</strong>
                <span>{{ convertLegendName(point.series) }}</span>
              </span>
            </el-tooltip>
          </li>
        </ul>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';

import { isEmpty } from '@/utils/basic';
import { getDateToString } from '@/utils/date';
import { lineOptions } from '@/constants/chart-options';
import { plotCharts } from '@/mixins/performance/charts';
import chartUtil from '@/utils/charts';
import AnalysisChartAPI from '@/api/performance/analysis/analysis-chart';

export default {
  name: 'WPeriodLineChart',
  mixins: [plotCharts],
  props: {
    rscInfoList: Array,
    dateParams: Object,
  },
  data() {
    return {
      options: cloneDeep(lineOptions),
    };
  },
  watch: {
    dateParams() {
      this.onShowChart();
    },
  },
  mounted() {
    const newOptions = this.options;
    const me = this;

    // 차트의 height 설정
    Object.assign(newOptions.chart, { height: 200 });
    Object.assign(newOptions.plotOptions.series, {
      point: {
        events: {
          mouseOver() {
            me.setCustomTooltip();
          },
        },
      },
      events: {
        mouseOut() {
          me.setCustomTooltip('init', false);
        },
      },
    });

    newOptions.xAxis.labels.format = '{value: %Y-%m-%d<br />%H:%M:%S}';
    newOptions.chart.events = {
      load() {
        if (this.hasOwnProperty('series')) {
          const series = this.series;
          // 시리즈가 8개 이상일 경우 최대 8개만 표현하고 나머지는 hidden처리한다.
          if (series.length > 8) {
            const excessSeries = series.slice(8, series.length);
            excessSeries.forEach((line) => line.hide());
          }
        }
      },
    };

    newOptions.tooltip = {
      formatter() {
        return getDateToString(this.key);
      },
    };
  },
  methods: {
    /**
     * 차트의 성능정보를 가져온다.
     * @return {[type]} [description]
     * @author jda
     */
    onShowChart() {
      const rscInfoList = this.rscInfoList;
      if (isEmpty(rscInfoList)) {
        return;
      }

      const params = Object.assign({}, { rscInfoList }, { statType: rscInfoList.statType }, this.dateParams);
      AnalysisChartAPI.getPerformanceChartData(params).then((response) => {
        if (response.data.success) {
          this.options.series = response.data.data;
          chartUtil.setYAxisRange(this.options);
          this.$nextTick(() => {
            this.setCustomTooltip('init', false);
          });
        }
      });
    },
    /**
     * 범례에 표현할 이름을 반환한다.
     * @param  {[type]} series [description]
     * @return {[type]}        [description]
     * @author jda
     */
    convertLegendName(series) {
      if (isEmpty(series)) {
        return null;
      }

      const rscInfo = series.options.rscInfo;
      if (!isEmpty(rscInfo)) {
        return isEmpty(rscInfo.rscKey) ? `${rscInfo.rscName}` : `${rscInfo.rscName} ${rscInfo.rscKeyName}`;
      }
      return series.name;
    },
    /**
     * 범례의 장비명을 표현한다.
     * @param  {[type]} series [description]
     * @return {[type]}        [description]
     * @author jda
     */
    convertObjName(series) {
      if (isEmpty(series)) {
        return null;
      }

      const rscInfo = series.userOptions.rscInfo;
      return isEmpty(rscInfo) ? null : rscInfo.objName;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/popup/ResourceComparePeriodPopup/components/PeriodLineChart.vue